import React, { useEffect, useState, useRef } from "react";
import NotificationAlert from "react-notification-alert";
import { useSelector } from "react-redux";
import { addTechnicianAvaiability } from "actions/technicianAvailability";

const days = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];
const disabledDays = []; // ["FRIDAY", "SATURDAY"]

//get the technician availability data from techniciandetail &  id
export default function AvailabilitySelector({
  technicianAvailability,
  technicianID,
}) {
  const notificationAlertRef = useRef(null);
  const [availability, setAvailability] = useState({});

  const timeSlots = useSelector(
    (state) => state.technicianAvailability.timeSlotsList?.data?.TimeSlot || []
  );

  useEffect(() => {
    //check timeSlot and technician availability ->if null -> return
    if (!technicianAvailability || !timeSlots.length) return;

    const formatted = {};
    //keys = get all the days--> [monday , tuesday ,..]
    Object.keys(technicianAvailability).forEach((day) => {
      //map the available slots of technician
      const availableSlots = technicianAvailability[day]
        .filter((slot) => slot.isAvailable) //keep only the slots that are available.
        .map((slot) => {
          const matched = timeSlots.find((t) => t.ID === slot.timeSlotID); //timeSlots {} -> ID matches -> slot.timeSlotID.
          return matched?.time;
        })
        .filter(Boolean); //remove undefined,null value
      formatted[day] = availableSlots;
    });
    setAvailability(formatted);
  }, [technicianAvailability, timeSlots]);

  const toggleSlot = async (day, slot) => {
    const slotObj = timeSlots.find((t) => t.time === slot);
    if (!slotObj) return;

    const timeSlotID = slotObj.ID; //get the ID
    const weekday = day;

    setAvailability((prev) => {
      const daySlots = prev[day] || [];
      const isSelected = daySlots.includes(slot);
      const newSlots = isSelected
        ? daySlots.filter((s) => s !== slot) //remove slot if already slected
        : [...daySlots, slot]; //add if not selected

      return {
        ...prev,
        [day]: newSlots,
      };
    });

    const bodyData = {
      technicianID,
      weekday,
      timeSlotID,
      isAvailable: !availability[day]?.includes(slot), // check prev slot of availablity
    };

    try {
      const res = await addTechnicianAvaiability(bodyData);
      if (res?.code === 200) {
        notify("success", res.message || "Availability updated successfully");
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to update availability!";
        notify("danger", message);
      }
    } catch (err) {
      notify("danger", "Failed to update availability!");
    }
  };

  const notify = (type, message) => {
    const options = {
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="weekly-availability card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered text-center align-middle mb-0">
              <thead className="thead-light">
                <tr>
                  <th>
                    <span className="full-text">Time Slots</span>
                  </th>
                  {days.map((day) => (
                    <th key={day} className="text-muted">
                      <span className="full-text">{day}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {timeSlots.map((slotObj) => {
                  const slot = slotObj.time;

                  return (
                    <tr key={slotObj.ID}>
                      <td className="font-weight-normal text-secondary">
                        {slot}
                      </td>

                      {days.map((day) => {
                        const isDisabled = disabledDays.includes(day);
                        const isSelected = availability[day]?.includes(slot);

                        return (
                          <td key={day}>
                            {isDisabled ? (
                              <span className="text-muted">--</span>
                            ) : (
                              <div
                                className={`check-cell ${
                                  isSelected ? "selected" : ""
                                }`}
                                onClick={() => toggleSlot(day, slot)}
                              >
                                {isSelected && (
                                  <i className="fa fa-check text-default avail-icon"></i>
                                )}
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
